import React, { useState } from 'react';
import InboundShield from './InboundShield';

/**
 * The Manufacturer Portal — atelier-facing surface.
 * Tabs are scaffolded here; current iteration ships the Inbound Shield.
 * (Iteration 11 parked: QC Lab Reports tab.)
 */
const TABS = [
  { id: 'inbound', label: 'Inbound Shield', Component: InboundShield },
];

const ManufacturerShell = () => {
  const [active, setActive] = useState(TABS[0].id);
  const ActiveComponent =
    TABS.find((t) => t.id === active)?.Component || TABS[0].Component;

  return (
    <div data-testid="manufacturer-shell" className="space-y-10">
      <nav
        data-testid="manufacturer-tabs"
        className="flex flex-wrap gap-2 border-b border-[#C1D7E2] pb-4"
      >
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setActive(t.id)}
            data-testid={`manufacturer-tab-${t.id}`}
            className={`px-4 py-2 text-[11px] tracking-[0.22em] uppercase font-medium border transition-colors ${
              active === t.id
                ? 'border-[#7C9CB1] bg-[#7C9CB1] text-[#F4F8F9]'
                : 'border-[#C1D7E2] text-[#7C9CB1] hover:bg-[#C1D7E2]/40'
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <ActiveComponent />
    </div>
  );
};

export default ManufacturerShell;
